const CLSTags = (doc, data, clinica) => {
    var CLS = doc.createElement("CSL");

    CLS.appendChild(SLDTags(doc, data, clinica));

   /*  data.recibosCaja.map((item, index) => {
        CLS.appendChild(USSTags(doc, data, clinica, item, index));
    }); */

    return CLS;
}

const SLDTags = (doc, data, clinica) => {
    var SLD = doc.createElement("SLD");

    //Codigo del Prestador de Servicios en Salud
    var SLD_1 = doc.createElement("SLD_1");
    SLD_1.innerHTML = clinica.cod_act_econ.substring(0, 10);
    SLD.appendChild(SLD_1);

    //Modalidades de Pago en Sector Salud
    var SLD_2 = doc.createElement("SLD_2");
    SLD_2.innerHTML = data.facturado.detallesPagoContrato.tipoContrato;
    SLD.appendChild(SLD_2);

    //Cobertura o Plan de Beneficios en Salud
    var SLD_3 = doc.createElement("SLD_3");
    SLD_3.innerHTML = data.facturado.detallesPagoContrato.planBeneficio;
    SLD.appendChild(SLD_3);

    // Numero del Contrato
    var SLD_4 = doc.createElement("SLD_4");
    SLD_4.innerHTML = data.facturado.detallesPagoContrato.numeroContrato;
    SLD.appendChild(SLD_4);

    //Numero de Poliza
    var SLD_5 = doc.createElement("SLD_5");
    SLD_5.innerHTML = "";
    SLD.appendChild(SLD_5);

    //nombre del miembro o unidad del sector
    var SLD_6 = doc.createElement("SLD_6");
    SLD_6.innerHTML = "Usuario1";
    SLD.appendChild(SLD_6);

    /* //Copago (Por el momento es el Total de los Copagos de la Factura)
    var SLD_7 = doc.createElement("SLD_7");
    SLD_7.innerHTML = data.totalCopagosReal;
    SLD.appendChild(SLD_7);

    //Cuota Moderadora
    var SLD_8 = doc.createElement("SLD_8");
    SLD_8.innerHTML = data.totalCuotaModeradora;
    SLD.appendChild(SLD_8);

    //Pagos Compartidos Voluntariosos en Salud
    var SLD_9 = doc.createElement("SLD_9");
    SLD_9.innerHTML = " ";
    SLD.appendChild(SLD_9);

    //Pagos Compartidos Voluntariosos en Salud
    var SLD_10 = doc.createElement("SLD_10");
    SLD_10.innerHTML = data.totalPagosCompartidosVoluntariosEnSalud;
    SLD.appendChild(SLD_10); */

    return SLD;
}

/* const USSTags = (doc, data, clinica, item, index) => {

        var USS = doc.createElement("USS");

        //Numero del Paciente
        var USS_1 = doc.createElement("USS_1");
        USS_1.innerHTML = item.num_documento_paciente;
        USS.appendChild(USS_1);
    
        //Scheme ID (Base de Datos)
        var USS_2 = doc.createElement("USS_2");
        USS_2.innerHTML = item.id_historia;
        USS.appendChild(USS_2);
    
        //Nombre del Paciente
        var USS_3 = doc.createElement("USS_3");
        USS_3.innerHTML = item.nombres;
        USS.appendChild(USS_3);
    
        //Apellidos del Paciente
        var USS_4 = doc.createElement("USS_4");
        USS_4.innerHTML = item.apellido1 + " " + item.apellido2;
        USS.appendChild(USS_4);
    
        return USS;
    

} */

export default CLSTags;